module.exports = __webpack_public_path__ + "img/bg8.28c6f8c8.jpg";